import { AnalysisResultsForCheckup } from '@companion-professional/dctypes';
import { useQuery } from '@tanstack/react-query';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import { getActiveCheckupItemMlResults } from '../lib/api';
import { useClinicId } from '../state/auth';


// useCheckupItemAnalysis is a hook that fetches the item ML results for the active checkups for the current clinic.
export const useCheckupItemAnalysis = () => {
  const enableAnalysisDisplay = useFeatureFlagEnabled('enableAnalysisDisplay');
  const clinicId = useClinicId();
  const {
    isPending,
    error,
    data: checkupItemAnalysisResults
  } = useQuery<Record<string, AnalysisResultsForCheckup>>({
    queryKey: ['active-checkups-item-analysis', clinicId],
    queryFn: () => {
      if (!enableAnalysisDisplay) {
        // If the feature flag is not enabled, we return an empty object
        return Promise.resolve({});
      }

      // If the feature flag is enabled, we fetch the ML results for the active checkup items
      return getActiveCheckupItemMlResults();
    }
  });

  return {
    isPending,
    error,
    checkupItemAnalysisResults: checkupItemAnalysisResults || {},
    enableAnalysisDisplay
  };
};
